(function (ws) {
    'use strict';

    ws.views.CustomerOnboarding = Backbone.View.extend({

        events: {
            'change input.attachmentUpload': 'updateList',
            'click .qut-attachments-del-click': 'deleteSelectedAttachment',
            'click input#files': 'resetList',
            'change #country-compAddr': 'searchSelectedLanguageChange',
            'change #country-mastercompAddr': 'searchSelectedLanguageChange',
            'change #country-vendorAddr': 'searchSelectedLanguageChange',
            'click .dropdown-button': 'onSelectOfMultiSelectDropDown',
            'change .dropdown-container': 'selectMultiselectOption',
            'click .submitOnboardingForms': 'onSubmitFormDetails',
            'click .saveData': 'saveAndContinueFunction',
            'click .deleteBank': 'deleteBankDetailsField',
            'click .rejectCOForm': 'rejectCustomerOnboardForm',
            'change input, select': 'getCurrentFieldValue',
            'click .tabnav': 'checkIfSaved',
            'change #phoneno': 'onChangeOfPhoneWithCountryCode',
            'click .toggleHistory-plus':'histroyPlus',
            'click .toggleHistory-minus':'histroyMinus'
        },
        /**
         * Initialize
         */
        initialize: function () {
            this.defaultTab = 0;
            this.totalBanks = 0;
            this.isValidForm = true;
            this.response = {};
            this.previousModel = new Backbone.Model();
            this.currentModel = new Backbone.Model();
            this.multiValueBank = {};
            this.allAddressDetails = {};
            this.allAddressQuestions = {};
            this.allAddressTypes = [];
            this.allBankDetails = [];
            this.findTabNumber = '';
            this.subBankFieldLabels = {};
            this.countrySelection = [];
            this.countryCode = [];
            this.nextQuestion = {};
            this.hasBeenRendered = [];
            this.subBankFieldLabels = {};
            this.multiCurrencyLists = {};
            this.lastAssocQuestionMediaToDownload = {};
            this.serverErrors = this.$('.serverErrors');
            this.prospectId = this.$('#prospectId').val();
            this.historyPlus = this.$('.toggleHistory-plus');
            this.historyMinus = this.$('.toggleHistory-minus');
            this.historyTab = this.$('.historyTab');
            this.mdmError = this.$('.mdm-global-error');
            this.pleaseSelectLabel = this.$('.defaultSelect').val();
            this.selectedtLabel = this.$('.selectedLabel').val();
            this.selectedCountryOnLoad = '';
            this.prospect = {prospectId: this.prospectId};
            this.zipCodeValidationApi = new ws.models.custOnboardingZipcodeValidation();
            this.customerOnboardingTabData = new ws.models.custOnboardingTabData(this.prospect);
            this.deleteSelectedAttachmentApi = new ws.models.deleteSelectedAttachment(this.prospect);
            this.custOnboardingReject = new ws.models.custOnboardingReject(this.prospect);
            this.eventAgg.on('showTabLevelError', this.showTabLevelError.bind(this));
            this.eventAgg.on('saveAndContinueFunction', this.saveAndContinueFunction.bind(this));
            this.eventAgg.on('onOnboardingSubmit', this.onOnboardingSubmit.bind(this));
            this.eventAgg.on('rejectCustomer', this.rejectCustomer.bind(this));
            this.eventAgg.on('checkIfLoggedOut', this.checkIfLoggedOut.bind(this));
            this.eventAgg.on('searchSelectedLanguageChange', this.searchSelectedLanguageChange.bind(this));
            this.eventAgg.on('mdmClose', this.mdmClose.bind(this));
            $(document).on('click', this.onDocumentClick.bind(this));
            this.getCountryCodeAndData();
        },

        onDocumentClick: function() {
            if (event && !$(event.target).closest('.multiSelectCheck').length) {
                this.$('.dropdown-list').css('display', 'none');
            }
        },

        mdmClose: function (isSaveOpen) {
            if (isSaveOpen) {
                this.isMDMValidForm = true;
                this.eventAgg.trigger('submitRequestModal');
            }
        },

        mdmValidation:  function() {
            this.numberOfAddressRequestedForMDM = 0;
            let allAddressGotMDMValidate = false;
            let addressCheck = false;
            _.each(this.allAddressTypes, (addr) => {
                if ($(this.$('.' + addr)[0]).find('span').length === 0) {
                    allAddressGotMDMValidate = true;
                }

                if (allAddressGotMDMValidate) {
                    return;
                }
            });

            if (allAddressGotMDMValidate) {
                let request = [];
                let requestObj = {};
                _.each(this.allAddressTypes, (addr) => {
                    let sameAsRegister = false;
                    if ($($('.' + addr)[0]).parent().parent().hasClass('isSameOptionAvailable')) {
                        let changeAddressName = addr === 'shipAddr' ? 'ShipAddr' : addr;
                        sameAsRegister = this.$('#is' + changeAddressName).is(':checked') === false;
                    }

                    if (!(sameAsRegister) && ($(this.$('.' + addr)[0]).find('span').length === 0)) {
                        let resObj = this.generateAddress('.' + addr);
                        resObj.addressName = addr;
                        request.push(resObj);
                    }
                });

                requestObj.prospectAddressList = request;
                let custOnboardingMdmValidation = new ws.models.custOnboardingMdmValidation(this.prospect);
                custOnboardingMdmValidation.set(requestObj);
                globals.disableApp();
                custOnboardingMdmValidation.save().done((data) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.mdmError.addClass('hidden');
                    this.eventAgg.trigger('accountAddAddressCustomerOnBoarding:open', data, this.allAddressTypes, this.numberOfAddressRequestedForMDM, this.allAddressQuestions);
                }).fail((jqXHR, exception) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.serverErrors.html('Error :' + exception).removeClass('hidden');
                });
            } else {
                this.isMDMValidForm = true;
                this.eventAgg.trigger('submitRequestModal');
            }
        },

        generateAddress: function (addressName) {
            this.numberOfAddressRequestedForMDM = this.numberOfAddressRequestedForMDM + 1;
            let address = {};
            let mdmParams = ['accountName', 'addressLine1', 'addressLine2', 'addressLine3', 'addressLine4', 'locality', 'city', 'zipCode', 'state', 'phone', 'fax', 'industry', 'country', 'type', 'language'];
            let htmlParams = ['company', 'streetname', 'streetnumber', 'building', 'line3', 'line4', 'town', 'postalcode', 'state', 'phone1', 'fax', 'industry', 'country', 'type', 'language'];

            _.each(this.$(addressName), function (items) {
                if ($(items).attr('name')) {
                    if (htmlParams.includes($(items).attr('name'))) {
                        address [mdmParams[htmlParams.indexOf($(items).attr('name'))]] = $(items).val();
                    }
                }
            });

            return address;
        },

        formBuild: function () {
            this.response.onboardingTabs.forEach((item) => {
                item.tabData.forEach((values, index) => {
                    if ((values.fieldType === 'ADDRESS' || values.fieldType === 'CONTACT') && values.answers) {
                        for (let [key, value] of Object.entries(values.answers)) {
                            this.previousModel.set({[key]: value});
                        }
                    } else if (values.fieldType === 'BANK' && values.bankdetails) {
                        const fields = values.bankdetails;
                        const banksList = fields.map((field) => field.bankDetails);
                        for (let t = 0; t < banksList.length; t++) {
                            for (let [key, value] of Object.entries(banksList[t])) {
                                this.previousModel.set({[(key) + (t + 1)]: value});
                            }
                        }
                    } else if (values.fieldType === 'Drop_Down_Multi' && values.dropDown) {
                        for (let t = 0; t < values.dropDown.length; t++) {
                            this.previousModel.set({[values.dropDown[t].value]: values.dropDown[t].selected});
                        }
                    } else {
                        this.previousModel.set({[values.questionId]: Object.values(values.answers ? values.answers : '').toString()});
                    }
                });
            });

            let formMessage = this.$('.formMesssage').val();
            this.$('.gl-title h2').html(`${formMessage} - ${this.response.prospectId}`);
            this.selectedCountryOnLoad = this.response.country;
            let getDefaultDateFormat = this.response.dateFormat;
            this.response.onboardingTabs.forEach((item) => {
                this.defaultTab = this.response.defaultTab ? Number(this.response.defaultTab) : 1;
                this.createTabs(item.tabName, item.tabNumber);
                if (item.tabData) {
                    item.tabData.forEach((values, index) => {
                        if(values.questionId === 'localAddr') {
                            values.question = $('.arabicHeader').val();
                        }

                        this.nextQuestion = item.tabData[index + 1];
                        switch (values.fieldType) {
                            case 'TEXT':
                            case 'NUMBER':
                            case 'EMAIL':
                            case 'STRING': this.createInputFields(item.tabNumber, 'text', values); break;
                            case 'DATE': this.createDateFields(item.tabNumber, values, getDefaultDateFormat); break;
                            case 'PHONE': this.phoneWithCountryCode(item.tabNumber, values); break;
                            case 'Drop_Down_Single': this.createSingleSelectDropDown(item.tabNumber, values); break;
                            case 'COUNTRY_SINGLE': this.createSingleSelectDropDown(item.tabNumber, values); break;
                            case 'Drop_Down_Multi': this.createMultiSelectDropDown(item.tabNumber, values); break;
                            case 'Header': this.createHeader(item.tabNumber, values); break;
                            case 'BOOLEAN': this.createCheckBoxesFields(item.tabNumber, values); break;
                            case 'BANK': this.bankDetailsField(item.tabNumber, values); break;
                            case 'CONTACT':
                            case 'ADDRESS': this.populateDefaultFields(item.tabNumber, values); break;
                            case 'ATTACHMENTTYPE_SINGLE':
                            case 'MEDIA_UPLOAD':
                            case 'MEDIA_DOWNLOAD': this.eventAgg.trigger('createAttachmentField', item.tabNumber, values, this.hasBeenRendered); break;
                        }
                        if (item.tabData.length === index + 1) {
                            this.appendButtons(item.tabNumber);
                        }
                    });
                }
            });

            this.eventAgg.trigger('reInitializeTab');
            this.createEvents();
            if (this.response.lockedByUser) {
                this.eventAgg.trigger('customerOnboardingLockedModal', this.response.lockedByUser);
            }

            if ($('#formStatus').val() === 'COMPLETED') {
                $('input,select,textarea,button').attr('disabled', 'true');
                $('.addMargin').hide();
            }
        },

        toggleMultiSelectDependent: function (e, tabNum, questionId, assocQuestions) {
            var associatedQuestions = {};
            var tabNumbers = '';
            var id = '';
            if (assocQuestions) {
                associatedQuestions = assocQuestions;
                tabNumbers = tabNum;
                id = questionId;
            } else {
                tabNumbers = Number($('.customer-onboarding ul').find('li.selected').data('tab'));
                id = e.currentTarget.id;
                let tabData = [];
                this.response.onboardingTabs.some((tab) => {
                    if (Number(tab.tabNumber) === tabNumbers) {
                        tabData = tab.tabData;
                        return true;
                    }
                });

                tabData.some((item) => {
                    if (item.questionId === id) {
                        associatedQuestions = item.associatedQuestions;
                        return true;
                    }
                });
            }

            let currentTabPath = `.customer-onboarding .tab-content[data-tab="${tabNumbers}"]`;
            let selectedValueshtml = $(`#${id}`).find('[type="checkbox"]:checked');
            let selectedValues = [];
            for (let [key, value] of Object.entries(selectedValueshtml)) {
                if (value.value) {
                    let valueToLower = value.value;
                    selectedValues.push(valueToLower.toLowerCase());
                }
            }

            for (let [key, value] of Object.entries(associatedQuestions)) {
                if (selectedValues.indexOf(key.toLowerCase()) > -1) {
                    $(`${currentTabPath} #${value}`).parent().removeClass('hidden');
                } else {
                    $(`${currentTabPath} #${value}`).parent().addClass('hidden');
                }
            }
        },

        histroyPlus: function(e) {
            this.historyPlus.addClass('hidden');
            this.historyMinus.removeClass('hidden');
            this.historyTab.removeClass('hidden');
            this.eventAgg.trigger('tab-history', e);
        },

        histroyMinus: function() {
            this.historyMinus.addClass('hidden');
            this.historyPlus.removeClass('hidden');
            this.historyTab.addClass('hidden');

        },

        createEvents: function () {
            this.$('select').select2({
                dropdownAutoWidth: true,
                width: '100%',
                dropdownCssClass: 'customerOnboardingCls'
            });

            this.$('#phoneno, #currencyDropdown').select2({
                dropdownAutoWidth: true,
                width: '16.66667%',
                dropdownCssClass: 'customerOnboardingCls'
            });

            this.$('.check-dependent').change((e) => {
                if ($(e.currentTarget).data('assoc')) {
                    this.checkDependent(e);
                }
            });

            this.$('.country').change((e) => {
                if (this.allAddressTypes.includes($(e.target).attr('class').split(' ')[0])) {
                    this.updateStates(e);
                    this.zipCodeValidation(e);
                }
            });

            this.$('.addBank').click((e) => {
                this.bankDetailsAppendExtra(e);
            });

            this.$('input[name="postalcode"]').change((e) => {
                this.zipCodeValidation(e);
            });

            //on load zip code validation for zipcode
            this.zipCodeValidation(undefined, 'compAddr');
            this.zipCodeValidation(undefined, 'vendorAddr');
            this.zipCodeValidation(undefined, 'mastercompAddr');
            for (var i = 1; i <= this.response.onboardingTabs.length; i++) {
                this.onChangeOfPhoneWithCountryCode(undefined, i);
            }
        },

        updateList: function(e) {
            this.eventAgg.trigger('updateList', e, this.prospectId);
        },

        deleteSelectedAttachment: function(e) {
            this.eventAgg.trigger('deleteSelectedAttachment', e, this.prospectId);
        },

        resetList: function(e) {
            this.eventAgg.trigger('resetList', e, this.prospectId);
        },

        appendButtons: function (tabNumber) {
            let se = $('.defaultSE').val();
            let sc = $('.defaultSC').val();
            let item = `<div class="small-12 column addMargin">
            <input type="button"  value="${sc}"  key="${tabNumber}" class="saveAndContinue button saveData">
            <input type="button"  value="${se}" class="saveAndExit button saveData">
            <span class="showSuccessMessage" style="display: none;"></span></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
            this.onloadDepedentCheck(tabNumber);
        },

        checkDependent: function (e) {
            let currentTab = Number($('.customer-onboarding ul').find('li.selected').data('tab'));
            let changedField = e.currentTarget.id;
            let tabData = [];
            this.response.onboardingTabs.some((tab) => {
                if (Number(tab.tabNumber) === currentTab) {
                    tabData = tab.tabData;
                    return true;
                }
            });

            tabData.some((item) => {
                if (item.questionId === changedField) {
                    this.toggleDependentTab(currentTab, changedField, item.associatedQuestions, e.currentTarget.value);
                    return true;
                }
            });

            if (['isShipAddr', 'isbillAddr'].includes(changedField)) {
                $(e.currentTarget).parent().next().addClass('hiddenLabel');
                $(e.currentTarget).parent().next().find('ul').remove();
                this.showTabLevelError();
            }
        },

        onloadDepedentCheck: function (tabNumber) {
            let tabData = [];
            this.response.onboardingTabs.some((tab) => {
                if (Number(tab.tabNumber) === Number(tabNumber)) {
                    tabData = tab.tabData;
                    return true;
                }
            });

            tabData.map((item) => {
                if (item.associatedQuestions && Object.keys(item.associatedQuestions).length) {
                    if (item.fieldType === 'Drop_Down_Multi') {
                        this.toggleMultiSelectDependent(undefined, tabNumber, item.questionId, item.associatedQuestions);
                    } else {
                        this.toggleDependentTab(tabNumber, item.questionId, item.associatedQuestions);
                    }
                }
            });
        },

        toggleDependentTab: function (currentTab, changedField, changedFieldDependents) {
            let currentTabPath = `.customer-onboarding .tab-content[data-tab="${currentTab}"]`;
            let typeOfField = $(`.customer-onboarding .tab-content[data-tab="${currentTab}"] #${changedField}`).prop('type');
            let changedFieldValue = typeOfField === 'checkbox' ? $(`${currentTabPath} #${changedField}`).prop('checked') ? 'true' : 'false' : $(`${currentTabPath} #${changedField}`).val();

            Object.entries(changedFieldDependents).forEach(([key, value]) => {
                value.split(',').forEach((dependentFieldID) => {
                    if ($(`${currentTabPath} .${dependentFieldID}`).hasClass('isAddress') || $(`${currentTabPath} .${dependentFieldID}`).hasClass('isContact') || $(`${currentTabPath} .${dependentFieldID}`).hasClass('isBank')) {
                        if (($(`${currentTabPath} #${changedField}`).prop('checked')).toString() === key) {
                            $(`${currentTabPath} .${dependentFieldID}`).parent().removeClass('hidden');
                        } else {
                            $(`${currentTabPath} .${dependentFieldID}`).parent().addClass('hidden');
                        }
                    } else {
                        if (key === changedFieldValue) {
                            if ($(`${currentTabPath} #${dependentFieldID}`).parent().hasClass('hidden')) {
                                $(`.customer-onboarding .tab-content[data-tab="${currentTab}"] #${dependentFieldID}`).parent().removeClass('hidden');
                            } else if ($(`${currentTabPath} .${dependentFieldID}`).hasClass('hidden')) {
                                $(`.customer-onboarding .tab-content[data-tab="${currentTab}"] .${dependentFieldID}`).removeClass('hidden');
                            }
                        } else {
                            if ($(`${currentTabPath} .${dependentFieldID}`).hasClass('small-12') && !$(`${currentTabPath} .${dependentFieldID}`).hasClass('hidden')) {
                                $(`.customer-onboarding .tab-content[data-tab="${currentTab}"] .${dependentFieldID}`).addClass('hidden');
                            } else if (!$(`${currentTabPath} #${dependentFieldID}`).parent().hasClass('hidden')) {
                                $(`${currentTabPath} #${dependentFieldID}`).parent().addClass('hidden');
                            }
                        }
                    }
                });
            });
        },

        addHeaderIfPresent: function (tabNumber, data) {
            let hasHeader = data.header ? data.header : '';
            let smallTextForHeader = data.questionId === 'reburaConsent' ? 'labelSmall' : '';
            if (hasHeader) {
                let addHeader = `<div class='small-12 column'><label class='${hasHeader} ${smallTextForHeader} label'">${hasHeader}</label></div>`;
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(addHeader);
            }
        },

        createTabs: function (tabName, tabNumber) {
            let addDefault = Number(tabNumber) === this.defaultTab ? 'data-default' : '';
            let itemHead = `<li data-tab="${tabNumber}" tabNumber="${tabNumber}" name="${tabNumber}" ${addDefault} class="${tabNumber} tab-${tabNumber} tabnav">${tabName}&nbsp;
                            <span class="showTabError"></span></li>`;
            let itemBody = `<div class="tab-content" id="tab-${tabNumber}" data-tab="${tabNumber}">
                            <div class="row"></div></div>`;
            $(`.comp-tabs[data-name='customerOnboarding'] .tabs-menu ul`).append(itemHead);
            $(`.comp-tabs[data-name='customerOnboarding'] .content`).append(itemBody);
        },

        createHeader: function (tabNumber, data) {
            let isChild = data.isChild ? 'hidden' : '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let item = `<div class="small-12 column ${isChild}">${data.question}${required}</div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
        },

        createDateFields: function (tabNumber, data, getDefaultDateFormat) {
            let isChild = data.isChild ? 'hidden' : '';
            let hasAssociation = data.associatedQuestions ? Object.keys(data.associatedQuestions).length ? 'hasAssoc' : '' : '';
            let selected = data.answers && 'textAnswer' in data.answers ? data.answers.textAnswer : '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
                return true;
            }

            var item = `<div class='small-4 column ${isChild}'><p><label title='${data.question}' for="${data.questionId}">${data.question}${required}</label>${tooltipText}</p><input style="padding-left: 40px;" tabNumber="${tabNumber}" ${requiredText} name="${data.questionId}" type='text' id="${data.questionId}" class="check-dependent datePicker" data-assoc="${hasAssociation}"><span class="calendar"/></input><span class="error customError hidden"></span></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);

            this.$('.datePicker').pikaday({format: getDefaultDateFormat.toUpperCase()});
            if (selected !== undefined) {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${data.questionId}`).val(selected);
            }
        },

        createInputFields: function (tabNumber, fieldType, data) {
            fieldType = data.fieldType === 'EMAIL' ? 'email' : data.fieldType === 'NUMBER' ? 'number' : fieldType;
            let isChild = data.isChild ? 'hidden' : '';
            let hasAssociation = data.associatedQuestions ? Object.keys(data.associatedQuestions).length ? 'hasAssoc' : '' : '';
            let selected = data.answers && 'textAnswer' in data.answers ? data.answers.textAnswer : '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';
            let fieldLength = data.question.length > 75 ? 'small-12' : 'small-4';
            let labelLenthOverRemoveOverflow = fieldLength === 'small-12' ? 'displayFull' : '';

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
                return true;
            }

            var item = `<div class='${fieldLength} column ${isChild} ${labelLenthOverRemoveOverflow ? 'fieldShrink' : ''}'><p><label class="${labelLenthOverRemoveOverflow}" title='${data.question}' for="${data.questionId}">${data.question}${required}</label>${tooltipText}</p>
                        <input tabNumber="${tabNumber}" ${requiredText} type=${fieldType} name="${data.questionId}" id="${data.questionId}" class="check-dependent" data-assoc="${hasAssociation}"/><span class="error customError hidden ${fieldLength === 'small-12' ? 'customErrorBiggerText' : ''}"></span></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);

            if (fieldType === 'number') {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).find(`#${data.questionId}`).attr('onkeydown', 'return event.keyCode !== 69');
            }

            if (selected !== undefined) {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${data.questionId}`).val(selected);
            }
        },

        createCheckBoxesFields: function (tabNumber, data) {
            let isChild = data.isChild ? 'hidden' : '';
            let hasAssociation = data.associatedQuestions ? Object.keys(data.associatedQuestions).length ? 'hasAssoc' : '' : '';
            let isLabel = hasAssociation || data.question.length > 75 ? 'small-12' : 'small-4';
            let isLabelField = hasAssociation ? 'label' : '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';
            var selected = data.answers.textAnswer && data.answers.textAnswer === 'true' ? 'checked' : '';
            let addDownloadLabel = '';
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
                return true;
            }

            if (hasAssociation && this.nextQuestion && this.nextQuestion.fieldType === 'MEDIA_DOWNLOAD') {
                for (let [key, value] of Object.entries(this.nextQuestion.answers)) {
                    addDownloadLabel = `<a href="${value}" download><b>Download File</b></a>`;
                }

                this.hasBeenRendered.push(this.nextQuestion.questionId);
            }

            let item = `<div class='${isLabel} column checkbox-field ${isChild}'>
                        <input ${requiredText} tabNumber="${tabNumber}" ${selected} id="${data.questionId}" name="${data.questionId}" class="check-dependent custom-checkbox" data-assoc="${hasAssociation}" type="checkbox">
                        <label class='${isLabelField} custom-checkbox-label' title='${data.question}' for="${data.questionId}">${data.question}${required}  ${addDownloadLabel}</label>
                        <span class="error customError hidden"></span>
                        </div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
            if (selected !== undefined) {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${data.questionId}`).prop('checked', selected);
            }
        },

        createSingleSelectDropDown: function (tabNumber, data) {
            let isChild = data.isChild ? 'hidden' : '';
            let options = data.fieldType === 'COUNTRY_SINGLE' ? '<option value="">' + $('.defaultSelect').val() + '</option>' : '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';
            let hasAssociation = data.associatedQuestions ? Object.keys(data.associatedQuestions).length ? 'hasAssoc' : '' : '';
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';
            let fieldLength = data.question.length > 75 ? 'small-12' : 'small-4';
            let labelLenthOverRemoveOverflow = fieldLength === 'small-12' ? 'displayFull' : '';

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
                return true;
            }

            if (data.fieldType === 'COUNTRY_SINGLE') {
                let selectedCountry = data.answers && 'textAnswer' in data.answers ? data.answers.textAnswer : '';
                _.each(this.countrySelection, option => {
                    let selectedOption = option.isocode === selectedCountry ? 'selected' : '';
                    options += `<option value="${option.isocode}" ${selectedOption}>${option.name}</option>`;
                });
            } else {
                _.each(data.dropDown, option => {
                    let selectedOption = option.selected ? 'selected' : '';

                    if (option.name ? option.name.includes('default.lookup.option.name') : false) {
                        options += `<option value="${option.value}"  ${selectedOption}>${$('.defaultSelect').val()}</option>`;
                    } else {
                        options += `<option value="${option.value}" ${selectedOption}>${option.name}</option>`;
                    }
                });
            }

            var item = `<div class='${fieldLength} column ${isChild} ${labelLenthOverRemoveOverflow ? 'fieldShrink' : ''}'><p><label class="${labelLenthOverRemoveOverflow}" for=${data.questionId}>${data.question}${required}</label>${tooltipText}</p>
                        <select ${requiredText} data-assoc="${hasAssociation}" id="${data.questionId}" name="${data.questionId}" class="check-dependent" tabNumber="${tabNumber}">
                            ${options}
                        </select>
                        <span class="error customError hidden ${fieldLength === 'small-12' ? 'customErrorBiggerText' : ''}"></span>
                     </div>`;

            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
        },

        createMultiSelectDropDown: function (tabNumber, data, path) {
            let selectionCount = 0;
            let isChild = data.isChild ? 'hidden' : '';
            let options = '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';
            let fieldLength = data.question.length > 75 ? 'small-12' : 'small-4';
            let labelLenthOverRemoveOverflow = fieldLength === 'small-12' ? 'displayFull' : '';
            let id = data.id ? data.id : '';
            let fieldName = data.fieldName ? data.fieldName : '';

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
                return true;
            }

            _.each(data.dropDown, option => {
                if (!(option.name ? option.name.includes('default.lookup.option.name') : false)) {
                    let selectedOption = option.selected ? 'checked' : '';
                    selectionCount += selectedOption !== '' ? 1 : 0;
                    options += `<li><input tabNumber="${tabNumber}" name="${option.value}" value="${option.value}" type="checkbox" ${selectedOption}><label for="${option.value}">${option.name}</label></li>`;
                }
            });

            let addLabel = selectionCount > 0 ? this.selectedtLabel : this.pleaseSelectLabel;
            let item = `<div class='${fieldLength} column ${isChild} ${id} ${labelLenthOverRemoveOverflow ? 'fieldShrink' : ''}'><p><label class="${labelLenthOverRemoveOverflow}" title='${data.question}' for=${data.questionId}>${data.question}${required}</label>${tooltipText}</p>
                        <div class="dropdown-container multiSelectCheck ${requiredText}" id="${data.questionId}">
                           <div class="dropdown-button noselect">
                              <div class="dropdown-label">${addLabel}</div>
                              <div style='float:right; margin-top: 0.2rem; font-size: 9px;' class="dropdown-arrow">&#9660;</div>
                           </div>
                           <div class="dropdown-list ${data.questionId} ${fieldName}" style="display: none;" test="${data.questionId}">
                              <ul></ul>
                           </div>
                        </div>
                        <span class="error customError hidden"></span>
                     </div>`;
            if (path) {
                path.before(item);
            } else {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
            }

            if (id) {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .${id}`).find(`#${data.questionId} .dropdown-list ul`).append(options);
            } else {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${data.questionId} .dropdown-list ul`).append(options);
            }

        },

        onSelectOfMultiSelectDropDown: function (e) {
            $(e.currentTarget).next('.dropdown-list').toggle();
        },

        selectMultiselectOption: function (e) {
            var container = $(e.currentTarget).closest('.dropdown-container');
            var numChecked = container.find('[type="checkbox"]:checked').length;
            var label = numChecked ? this.selectedtLabel : this.pleaseSelectLabel;
            container.find('.dropdown-label').text(label);
            if (label === this.selectedtLabel) {
                $(e.currentTarget).closest('.dropdown-container').removeClass('error-border');
                $(e.currentTarget).closest('.dropdown-container').parent().find('.customError').html('').removeClass('show');
            }

            this.toggleMultiSelectDependent(e);
        },

        bankDetailsAppendExtra: function (e) {
            let getDeleteBankLabel = $('.deleteBankLabel').val();
            this.totalBanks += 1;
            let id = 'Bank' + this.totalBanks;
            let fieldName = e.currentTarget.classList[1];
            let tabNumber = $('.customer-onboarding ul .selected').data('tab');
            let deleteButton = `<input class='${id} deleteBank button' name="${fieldName}" getid="${id}" style="float:right;"type='button' value='${getDeleteBankLabel}' />`;
            let fieldType = 'isBank';
            let fieldPath = $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).find(`.${fieldName}-bank`);
            let label = 'Bank' + this.totalBanks;

            let fieldLabel = `<div class='small-12 column ${id}'><label class='${fieldName} ${fieldType} label'>${label}</label>${deleteButton}</div>`;
            fieldPath.before(fieldLabel);

            for (let [key, value] of Object.entries(this.subBankFieldLabels)) {
                let required = '';
                let requiredText = '';

                if (this.bankValidations) {
                    if (key in this.bankValidations) {
                        required = '*';
                        requiredText = 'required';
                    }
                }

                if (key !== 'currencyList' && key !== 'country' && key !== 'state') {
                    let item = `<div class='small-4 column ${id}'><label title='${value}' for="${key}-${this.totalBanks}">${value}${required}</label><input ${requiredText} type="text" class="${fieldName}" tabNumber="${tabNumber}" name="${key}${this.totalBanks}" id="${key}-${this.totalBanks}"/><span class="error customError hidden"></span></div>`;
                    fieldPath.before(item);
                } else if (key === 'currencyList') {
                    let currencyListData = {
                        id: id,
                        isChild: '',
                        fieldName: key + '-' + this.totalBanks,
                        questionId: fieldName,
                        question: value,
                        validations: {
                            MANDATORY: key in this.bankValidations
                        },
                        dropDown: this.multiCurrencyLists
                    };
                    this.createMultiSelectDropDown(tabNumber, currencyListData, fieldPath);
                } else {
                    let item = `<div class='small-4 column ${id}'><label title='${value}' for=${key}-${this.totalBanks}>${value}${required}</label>
                           <select id="${key}-${this.totalBanks}" class="${fieldName} ${key}" name="${key}${this.totalBanks}" ${requiredText} tabNumber="${tabNumber}">
                           </select>
                           <span class="error customError hidden"></span>
                        </div>`;

                    fieldPath.before(item);

                    if (key === 'country') {
                        this.getCountryData(tabNumber, key + '-' + this.totalBanks);
                    } else if (key === 'state') {
                        let container = $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`);
                        this.updateStates(undefined, container);
                    }
                }
            }

            let appendEmptyLabel = `<div class="small-12 column ${id} ${this.totalBanks}-end"><label class="${fieldName}></label></div>`;
            fieldPath.before(appendEmptyLabel);
        },

        deleteBankDetailsField: function (e) {
            let tabNumber = $('.customer-onboarding ul .selected').data('tab');
            let fieldName = e.currentTarget.classList[0];
            let getKey = $(e.target).attr('name');
            var getIdDetails = $(e.target).attr('getid').replace(/^\D+/g, '');

            let bankId = $('#bankId-' + getIdDetails).val();
            var dataPost = {
                questionID: getKey,
                attribute: {
                    bankId: bankId
                }
            };

            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`.${fieldName}`).remove();
            globals.disableApp();
            $.ajax({
                url: globals.path.api.westcon.removeBankDetails + this.prospectId + '?' + CSRF,
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(dataPost)
            }).done((response) => {
                globals.enableApp();
                this.serverErrors.html('');
                if (response.save === 'true') {
                    console.log('removed the Bank successfully');
                }
            }).fail((jqXHR, exception) => {
                globals.enableApp();
                this.serverErrors.html('');
                this.serverErrors.html('Error :' + exception).removeClass('hidden');
            });
        },

        bankDetailsField: function (tabNumber, data) {
            let isChild = data && data.isChild ? 'hidden' : '';
            let fieldType = 'isBank';
            let fieldPath = $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`);
            this.subBankFieldLabels = data.questionLabels ? data.questionLabels : '';
            this.allBankDetails.push(data.questionId);
            let getDeleteBankLabel = $('.deleteBankLabel').val();
            let addBankLabel = $('.addAnBankLabel').val();
            let fieldValues = [];
            if (data && data.bankdetails) {
                fieldValues = data.bankdetails.map((field) => field.bankDetails);
            } else {
                fieldValues = [{a: 1}];
            }

            fieldValues.forEach((fields) => {

                this.totalBanks += 1;
                let label = this.totalBanks === 1 ? data.question : 'Bank' + this.totalBanks;
                let id = 'Bank' + this.totalBanks;
                let labelHide = isChild && this.totalBanks === 1 ? 'hiddenLabel' : '';
                let deleteButton = this.totalBanks === 1 ? '' : `<input class='${id} deleteBank button' name="${data.questionId}" getid="${id}" style="float:right;"type='button' value='${getDeleteBankLabel}' />`;
                let getSelectedCountry = fields.country ? fields.country : '';
                let addHiddenFields = fields.bankId ? fields.bankId : '';
                this.multiCurrencyLists = {};
                this.multiCurrencyLists = fields.currencyList ? fields.currencyList : '';
                let createBankIdFields = `<input type="hidden" value="${addHiddenFields}" id="bankId-${this.totalBanks}"/>`;
                let fieldLabel = `<div class='small-12 column ${isChild} ${id}'>
                <label class='${data.questionId} ${labelHide} ${fieldType} label'">${label}</label>${deleteButton}${createBankIdFields}</div>`;
                fieldPath.append(fieldLabel);

                for (let [key, value] of Object.entries(this.subBankFieldLabels)) {
                    this.bankValidations = data.fieldValidations;
                    let required = '';
                    let requiredText = '';

                    if (this.bankValidations) {
                        if (key in this.bankValidations) {
                            required = '*';
                            requiredText = 'required';
                        }
                    }

                    if (key !== 'currencyList' && key !== 'country' && key !== 'state') {
                        let item = `<div class='small-4 column ${isChild} ${id}'>
                        <label title='${value}' for="${key}-${this.totalBanks}">${value}${required}</label>
                        <input tabNumber="${tabNumber}" ${requiredText} getaccountNumer="${key}" type="text" class="${data.questionId}" name="${key}${this.totalBanks}" id="${key}-${this.totalBanks}"/>
                        <span class="error customError hidden"></span></div>`;
                        fieldPath.append(item);
                        if (Object.keys(fields).length) {
                            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${key}-${this.totalBanks}`).val(fields[key]);
                        }

                    } else if (key === 'currencyList') {
                        let currencyListData = {
                            id: id,
                            isChild: data.isChild,
                            fieldName: key + '-' + this.totalBanks,
                            questionId: data.questionId,
                            question: value,
                            validations: {
                                MANDATORY: key in this.bankValidations
                            },
                            dropDown: this.multiCurrencyLists
                        };
                        this.createMultiSelectDropDown(tabNumber, currencyListData);
                    } else {
                        let item = `<div class='small-4 column ${isChild} ${id}'><label title='${value}' for=${key}-${this.totalBanks}>${value}${required}</label>
                           <select id="${key}-${this.totalBanks}" class="${data.questionId} ${key}" name="${key}${this.totalBanks}" ${requiredText} tabNumber="${tabNumber}">
                           </select>
                           <span class="error customError hidden"></span>
                        </div>`;

                        $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);

                        if (key === 'country') {
                            this.getCountryData(tabNumber, key + '-' + this.totalBanks, getSelectedCountry);
                        } else if (key === 'state') {
                            let container = $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`);
                            this.updateStates(undefined, container);
                        }

                        if (Object.keys(fieldValues).length) {
                            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${key}`).val(fieldValues[key]);
                        }

                    }
                }
            });

            let appendEmptyLabel = `<div class="small-12 column ${this.totalBanks}-end"><label class="${data.questionId}></label></div>`;
            fieldPath.append(appendEmptyLabel);

            let appendAddButton = `<div class="${data.questionId}-bank small-12 column"><input class='addBank ${data.questionId} button' style="float:left;" type='button' value='${addBankLabel}' /></div>`;
            fieldPath.append(appendAddButton);
        },

        populateDefaultFields: function (tabNumber, data) {
            let isChild = data.isChild ? 'hidden' : '';
            let labelHide = isChild ? 'hiddenLabel isSameOptionAvailable' : '';
            let fieldTypes = {ADDRESS: 'isAddress', CONTACT: 'isContact'};
            let fieldType = fieldTypes[data.fieldType];
            let subFieldLabels = data.questionLabels ? data.questionLabels : '';
            this.allAddressTypes.push(data.questionId);
            this.allAddressQuestions[data.questionId] = data.question;
            let tooltipText = data.tooltip ? `<span class='tooltip1'><img class="two" src="/store/_ui/desktop/theme-westcon/images/help-text.png" width="100" height="100"><span class="tooltiptext">${data.tooltip}</span></span>` : '';

            let fieldLabel = `<div class='small-12 column ${labelHide}'><p><label class='${data.questionId} ${fieldType}'>${data.question}<span class='hidden'>MDM Verified</span></label>${tooltipText}</p></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(fieldLabel);

            let fieldValues = {};
            if (data.answers && Object.keys(data.answers).length) {
                fieldValues = data.answers;
            }

            for (let [key, value] of Object.entries(subFieldLabels)) {
                let requiredFields = data.fieldValidations;
                let required = '';
                let requiredText = '';

                if (requiredFields) {
                    if (key in requiredFields) {
                        required = '*';
                        requiredText = 'required';
                    }
                }

                if (key !== 'currency' && key !== 'country' && key !== 'state') {
                    let fieldType = ['phone', 'phone1', 'fax'].includes(key) ? 'number' : 'text';
                    let item = `<div class='small-4 column ${isChild}'><a><label title='${value}' for="${key}">${value}${required}</label></a><input ${requiredText} type="${fieldType}" name="${key}" tabNumber="${tabNumber}" class="${data.questionId}" id="${key}"/><span class="error customError hidden"></span></div>`;
                    $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
                    if (Object.keys(fieldValues).length) {
                        $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .${data.questionId}#${key}`).val(fieldValues[key]);
                    }
                } else {
                    let item = `<div class='small-4 column ${isChild}'><a><label title='${value}' for=${key}>${value}${required}</label></a>
                           <select ${requiredText} id="${key}-${data.questionId}" class="${data.questionId} ${key}" name="${key}"  tabNumber="${tabNumber}">
                           </select>
                           <span class="error customError hidden"></span>
                        </div>`;

                    $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);

                    if (key === 'country') {
                        if (Object.keys(fieldValues).length) {
                            this.getCountryData(tabNumber, key + '-' + data.questionId, fieldValues[key]);
                        } else {
                            this.getCountryData(tabNumber, key + '-' + data.questionId);
                        }
                    } else if (key === 'state') {
                        if (Object.keys(fieldValues).length) {
                            this.updateStates(undefined, tabNumber, fieldValues[key], key + '-' + data.questionId);
                        } else {
                            this.updateStates(undefined, tabNumber, undefined, key + '-' + data.questionId);
                        }
                    }

                    if (Object.keys(fieldValues).length) {
                        $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${key}`).val(fieldValues[key]);
                    }
                }
            }

            let appendEmptyLabel = `<div class="small-12 column"><label title='${data.question}'></label></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(appendEmptyLabel);

        },

        getCountryCodeAndData: function () {
            globals.disableApp();
            this.countries = new ws.models.shippingCountryOnBoardingForm();
            this.countries.fetch({
                success: (response) => {
                    this.countrySelection = response.attributes;
                    _.each(response.attributes, options => {
                        this.countryCode.push({name: options.name, code: options.countryCode, isocode: options.isocode});
                    });

                    this.customerOnboardingTabData.fetch().done((formData) => {
                        globals.enableApp();
                        this.serverErrors.html('');
                        this.response = formData;
                        this.formBuild();
                        for (let x = 0; x < this.allAddressTypes.length; x++) {
                            this.allAddressDetails[this.allAddressTypes[x]] = {};
                        }
                    }).fail((jqXHR, exception) => {
                        globals.enableApp();
                        this.serverErrors.html('');
                        this.serverErrors.html('Error :' + exception).removeClass('hidden');
                    });
                },

                error:  () => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.serverErrors.html('Error : Countries API failed, Please contact Administrator').removeClass('hidden');
                }
            });
        },

        getCountryData: function (tabNumber, questionId, selected) {
            let keyOptions = '';
            let selectedCountry = selected ? selected : this.selectedCountryOnLoad;

            if (['country-compAddr', 'country-vendorAddr', 'country-mastercompAddr'].includes(questionId)) {
                selectedCountry = this.selectedCountryOnLoad;
            }

            _.each(this.countrySelection, options => {
                let selectedOption = options.isocode === selectedCountry ? 'selected' : '';
                keyOptions += `<option value="${options.isocode}" ${selectedOption}>${options.name}</option>`;
            });

            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"]`).find(`#${questionId}`).append(keyOptions);

        },

        updateStates: function (e, tabnumber, selectedValue, id) {
            var container = '';
            if (tabnumber) {
                container = $(`.customer-onboarding .tab-content[data-tab="${tabnumber}"]`);
            } else {
                container = $(e.currentTarget).parents('.tab-content');
            }

            let selectedCountry;
            if (e) {
                selectedCountry = $(e.currentTarget).val();
                id = $(e.currentTarget).attr('id').replace('country', 'state');
            } else {
                if (['compAddr', 'vendorAddr', 'mastercompAddr'].includes(id.split('-')[1])) {
                    selectedCountry = this.selectedCountryOnLoad;
                } else {
                    selectedCountry = selectedValue ? selectedValue.split('-')[0] : this.selectedCountryOnLoad;
                }
            }

            if (selectedCountry !== '') {
                var regions = new ws.collections.shippingStates([], {iso: selectedCountry});
                regions.fetch().done(function (response) {
                    let options = `<option value="">${this.pleaseSelectLabel}</option>`;
                    _.each(response, option => {
                        let selectedOption = option.isocode === selectedValue ? 'selected' : '';
                        options += `<option value="${option.isocode}" ${selectedOption}>${option.name}</option>`;
                    });

                    container.find('#' + id).empty().append(options);
                }.bind(this));
            }
        },

        mandatoryValidation: function () {
            let defaultTab = this.defaultTab;
            let errorMessage = this.$('.requiredMesssage').val();
            let selected = this.selectedtLabel;
            $('.customer-onboarding input, .customer-onboarding select, .customer-onboarding textarea, .customer-onboarding .multiSelectCheck').each(function () {
                let doValidation = $(this).closest('.tab-content').data('tab') <= defaultTab || defaultTab === 1 ? true : false;
                let getCheckedval = ($(this).val() === 'on' && $(this).prop('type') === 'checkbox') ? !$(this).is(':checked') : $(this).val() === '';
                if ($(this).attr('required') && $(this).prop('type') === 'file') {
                    if ($('.' + $(this).data('address')).hasClass('hidden') || $('.' + $(this).data('address')).find('.filesList').children().length) {
                        getCheckedval = false;
                        $(this).removeClass('error-border');
                        $(this).parent().find('.customError').html('').removeClass('show phoneValidate');
                        $(this).parent().find('.select2-selection__rendered').removeClass('error-border');
                    }
                }

                if (doValidation && $(this).attr('required') && getCheckedval && !$(this).parent().hasClass('hidden') || ($(this).hasClass('required') && $(this).find('.dropdown-label').html() !== selected) && doValidation) {
                    $(this).addClass('error-border');
                    if ($(this).prop('tagName') === 'SELECT') {
                        $(this).parent().find('.customError').html(errorMessage).addClass('show phoneValidate');
                        $(this).parent().find('.select2-selection__rendered').addClass('error-border');
                    } else {
                        $(this).parent().find('.customError').html(errorMessage).addClass('show');
                    }
                }
            });

            if ($('.error-border').length) {
                this.isValidForm = false;
            }

            this.showTabLevelError();
        },

        emailValidation: function (e, ele) {
            let isValidEmail;
            let element = ele ? ele : e.target;

            if ($(element).val() !== '') {
                isValidEmail = globals.validateEmail($(element).val());
                if (isValidEmail) {
                    $(element).removeClass('error-border');
                    $(element).parent().find('.customError').html('').removeClass('show');
                } else {
                    $(element).addClass('error-border');
                    $(element).parent().find('.customError').html('Please enter valid email').addClass('show');
                    this.isValidForm = false;
                }
            }
        },

        showTabLevelError: function () {
            $('.customer-onboarding .tab-content').each(function () {
                if ($(this).children().find('input, select, textarea, div.multiSelectCheck').hasClass('error-border')) {
                    $('.' + $(this).attr('id')).find('.showTabError').html('!').show();
                    this.isValidForm = false;
                } else if ($(this).children().find('li').hasClass('mdm-error-border')) {
                    $('.' + $(this).attr('id')).find('.showTabError').html('!').show();
                    this.isMDMValidForm = false;
                } else {
                    $('.' + $(this).attr('id')).find('.showTabError').html('').hide();
                }
            });
        },

        onChangeOfPhoneWithCountryCode: function (e, tabNumber) {
            let tabNumbers = tabNumber ? tabNumber : Number($('.customer-onboarding ul').find('li.selected').data('tab'));
            $(`.customer-onboarding .tab-content[data-tab="${tabNumbers}"] .row`).find('#select2-phoneno-container').text($(`.customer-onboarding .tab-content[data-tab="${tabNumbers}"] .row`).find('#phoneno').val());
        },

        phoneWithCountryCode: function(tabNumber, data) {
            let countryCodeOptions = '';
            let selected = data.answers && 'number' in data.answers ? data.answers.number : '';
            let selectedCountryCode = data.answers && 'countryCode' in data.answers ? data.answers.countryCode : this.selectedCountryOnLoad;
            let number = data.answers && 'number' in data.answers ? data.answers.number : '';
            let fieldLength = data.question.length > 75 ? 'small-12' : 'small-4';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';

            _.each(this.countryCode, options => {
                countryCodeOptions += `<option value="${options.code}"  ${options.code === selectedCountryCode ? 'selected' : ''} ${options.isocode === selectedCountryCode ? 'selected' : ''} >${options.name}, ${options.code}</option>`;
            });

            var item = `<div class='${fieldLength} column'><p style="display:block;"><label title='${data.question}' for="${data.questionId}">${data.question}${required}</label></p>
               <select class="small-2 column phoneSaveData" id="phoneno" tabNumber="${tabNumber}" name="${data.questionId}">
                  ${countryCodeOptions}
               </select>
               <input ${requiredText} type="number" value='${selected}' onkeydown="return event.keyCode !== 69" class="phone" name="${data.questionId}" tabNumber="${tabNumber}" value="${number}"/>
               <span class="error customError hidden phoneValidate"></span></div>`;

            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(item);
        },

        saveAndContinueFunction: function (e, from, country) {
            let targetVal = e ? e.target : '';
            if (this.currentModel.attributes.hasOwnProperty('compAddr') && Array.isArray(this.currentModel.attributes.compAddr.answer)) {
                let companyValue = $('.compAddr#company').val();
                this.currentModel.attributes.compAddr.answer[0].company = companyValue;
            }

            if (!_.isEmpty(this.currentModel.attributes)) {
                globals.disableApp();
                $.ajax({
                    url: globals.path.api.westcon.saveCustomerOnBoard + this.prospectId + '?' + CSRF,
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(this.currentModel)
                }).done((response) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.currentModel.clear();
                    if (targetVal) {
                        var tabKey = $(targetVal).attr('key') ? $(targetVal).attr('key') : $('li.selected').attr('tabnumber');
                        if (response.save === 'true' && $(targetVal).hasClass('changeCountryCls')) {
                            this.eventAgg.trigger('searchSelectedLanguage', from, country);
                        } else if (response.save === 'true' && ($(targetVal).hasClass('loggeOutCls') || $(targetVal).hasClass('saveAndExit'))) {
                            window.location.href = globals.path.api.westcon.logout;
                        } else {
                            if (response.save === 'true' && ($(targetVal).hasClass('saveAndContinue') || $(targetVal).hasClass('saveFormOnboarding'))) {
                                this.$('.showSuccessMessage').html('Saved Successfully!').fadeIn('slow').delay(2000).fadeOut('slow').css('color', 'green');
                                if ($(targetVal).hasClass('saveAndContinue')) {
                                    if (!(this.$(`li[data-tab=${tabKey}]`).is(':last-child'))) {
                                        this.$(`li[data-tab=${tabKey}]`).removeClass('selected');
                                        this.$(`li[data-tab=${tabKey}]`).next().addClass('selected');
                                        this.$(`#tab-${tabKey}`).css('display', 'none');
                                        this.$(`#tab-${tabKey}`).next().css('display', 'block');
                                        this.histroyMinus();
                                        $(window).scrollTop(0);
                                    }
                                }
                            } else {
                                this.$('.showSuccessMessage').html('Error! While Saving').fadeIn('slow').delay(2000).fadeOut('slow').css('color', 'Red');
                            }
                        }
                    }
                }).fail((jqXHR, exception) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.serverErrors.html('Error :' + exception).removeClass('hidden');
                });
            }
        },

        getCurrentFieldValue: function(e) {
            this.updateData = {answer: []};
            this.updateBankDetails = {answer: []};
            this.AddressDetails = {answer: []};
            this.multiValue = {};
            this.multiCurrencyValue = [];
            let currentElement = e.target;
            let currentElementName = e.target.name;
            let currentElementValue = e.target.value;
            let currentElementType = e.target.type;

            if (currentElementValue) {
                $(currentElement).removeClass('error-border');
                $(currentElement).parent().find('.customError').html('').removeClass('show phoneValidate');
                $(currentElement).parent().find('.select2-selection__rendered').removeClass('error-border');
            }

            if (currentElementType === 'email') {
                this.emailValidation(e);
            }

            this.showTabLevelError();
            if (currentElementType === 'checkbox' && $(currentElement).parentsUntil('dropdown-container').hasClass('multiSelectCheck')) {
                let getClassName = $(currentElement).parents('.dropdown-list').attr('test');
                _.each($('.' + getClassName + ' input'), ((ele) => {
                    if ($(ele).is(':checked') && $(ele).attr('name')) {
                        this.multiValue[$(ele).attr('name')] = $(ele).attr('name');
                    }
                }));

                this.updateData.answer.push(this.multiValue);
                if (this.previousModel.previous(currentElementName) !== currentElement.checked) {
                    if (this.allBankDetails.includes(getClassName)) {

                        var currencyClass = $(currentElement).parents('.dropdown-list').attr('class').split(' ')[2];
                        var currencyClassName = currencyClass.split('-')[0];
                        var currencyClassIndex = currencyClass.split('-')[1];
                        let name = currencyClassName + currencyClassIndex;
                        _.each($('.Bank' + currencyClassIndex + ' .multiSelectCheck .' + getClassName + ' input'), ((ele) => {
                            if ($(ele).is(':checked') && $(ele).attr('name')) {
                                this.multiCurrencyValue.push($(ele).attr('name'));
                            }
                        }));

                        for (var a = 0; a < $('.multiSelectCheck .' + getClassName).length; a++) {
                            this.multiValueBank[name] = this.multiCurrencyValue.toString();
                        }

                        var returnMultipleCurrencyObject = this.createMultipleObjects(this.multiValueBank);
                        for (var s in returnMultipleCurrencyObject) {
                            returnMultipleCurrencyObject[s].bankId = $('#bankId-' + s).val();
                            this.updateBankDetails.answer.push(returnMultipleCurrencyObject[s]);
                        }

                        this.currentModel.set({[getClassName]: this.updateBankDetails});

                    } else {
                        this.currentModel.set({[$(currentElement).parents('.dropdown-container').attr('id')]: this.updateData});
                    }

                } else {
                    this.currentModel.unset(currentElementName);
                }
            } else if ($(currentElement).hasClass('phone') || ($(currentElement).hasClass('small-2') && e.target.type === 'select-one')) {
                if (this.previousModel.previous(currentElementName) !== currentElementValue) {
                    this.updateData = {answer: [{
                                countryCode: $(currentElement).parent().find('select').val(),
                                number: $(currentElement).parent().find('input').val()
                            }]
                    };
                    this.currentModel.set({[currentElementName]: this.updateData});
                } else {
                    this.currentModel.unset(currentElementName);
                }

            } else if (['text', 'email', 'number'].includes(currentElementType) || (currentElementType === 'select-one' && !$(currentElement).hasClass('small-2'))) {
                if (this.allBankDetails.includes($(currentElement).attr('class').split(' ')[0])) {
                    var checkBankLabel = $(currentElement).attr('class').split(' ')[0];
                    if (this.previousModel.previous(currentElementName) !== currentElementValue) {
                        for (var t = 0; t < $('.' + checkBankLabel).length; t++) {
                            this.multiValueBank[currentElementName] = currentElementValue;
                        }

                        var returnMultipleObject = this.createMultipleObjects(this.multiValueBank);
                        for (var i in returnMultipleObject) {
                            returnMultipleObject[i].bankId = $('#bankId-' + i).val();
                            this.updateBankDetails.answer.push(returnMultipleObject[i]);
                        }

                        this.currentModel.set({[checkBankLabel]:  this.updateBankDetails});
                    } else {
                        var x = currentElementName.replace(/^\D+/g, '');
                        var converInt = parseInt(x);
                        delete this.currentModel.get(checkBankLabel).answer[converInt - 1][currentElementName.substring(0, currentElementName.length - 1)];
                        var getPlainObjects = this.currentModel.get(checkBankLabel).answer.filter(el => Object.keys(el).length);
                        this.currentModel.set({[checkBankLabel]: getPlainObjects});

                        if (Object.keys(this.currentModel.get(checkBankLabel).answer[0]).length === 0) {
                            this.currentModel.unset(checkBankLabel);
                        }
                    }
                } else if (this.allAddressTypes.includes($(currentElement).attr('class').split(' ')[0])) {
                    var checkAdrressLabel = $(currentElement).attr('class').split(' ')[0];
                    if (e.originalEvent || ['country', 'state'].includes($(e.target).attr('class').split(' ')[1])) {
                        $($('.' + checkAdrressLabel)[0]).find('span').remove();
                    }

                    if (this.previousModel.previous(currentElementName) !== currentElementValue) {
                        for (let z = 0; z < $('.' + checkAdrressLabel).length; z++) {
                            this.allAddressDetails[checkAdrressLabel][currentElementName] = currentElementValue;
                        }

                        let country = 'country';
                        this.allAddressDetails[checkAdrressLabel][country] = $('#country-' + checkAdrressLabel).val();
                        this.AddressDetails.answer.push(this.allAddressDetails[checkAdrressLabel]);
                        this.currentModel.set({[checkAdrressLabel]: this.AddressDetails});
                    } else {
                        if (this.currentModel.get(checkAdrressLabel)) {
                            delete this.currentModel.get(checkAdrressLabel).answer[0][currentElementName];
                            this.currentModel.set({[checkAdrressLabel]: this.currentModel.get(checkAdrressLabel)});

                            if (Object.keys(this.currentModel.get(checkAdrressLabel).answer[0]).length === 0) {
                                this.currentModel.unset(checkAdrressLabel);
                            }
                        }
                    }
                } else {
                    if (this.previousModel.previous(currentElementName) !== currentElementValue) {
                        this.updateData = {
                            answer:
                                [{
                                    textAnswer: currentElementValue
                                }]
                        };
                        this.currentModel.set({[currentElementName]: this.updateData});
                    } else {
                        this.currentModel.unset(currentElementName);
                    }
                }

            } else if (currentElementType === 'checkbox') {
                if (this.previousModel.previous(currentElementName) !== currentElement.checked.toString()) {
                    this.updateData = {
                        answer:
                            [{
                                textAnswer: currentElement.checked
                            }]
                    };
                    this.currentModel.set({[currentElementName]: this.updateData});
                } else {
                    this.currentModel.unset(currentElementName);
                }
            }

            if (Object.keys(this.currentModel.attributes).length > 0) {
                this.findTabNumber = $(currentElement).attr('tabNumber');
            }

            console.log(this.currentModel);
        },

        rejectCustomerOnboardForm: function() {
            this.eventAgg.trigger('rejectRequestModal');
        },

        rejectCustomer: function() {
            globals.disableApp();
            this.custOnboardingReject.save(null, {
                contentType: 'application/json',
                data: JSON.stringify({})
            }).done((response) => {
                globals.enableApp();
                this.serverErrors.html('');
                if (response.reject === 'true') {
                    this.eventAgg.trigger('customerOnboardingRejectModal');
                }
            }).fail((jqXHR, exception) => {
                globals.enableApp();
                this.serverErrors.html('');
                this.serverErrors.html('Error :' + exception).removeClass('hidden');
            });
        },

        createMultipleObjects: function(singleObj) {
            var res = Object.entries(singleObj).reduce((o, [k, v]) => {
                let [name, number] = k.match(/\D+|\d+$/g);
                o[number] =  Object.assign({}, (o[number] || {}), {[name]: v});
                return o;
            }, {});
            return res;
        },

        onSubmitFormDetails: function() {
            this.isValidForm = true;
            this.mandatoryValidation();
            _.each(this.$('input[type="email"]'), (e) => {
                this.emailValidation(undefined, e);
            });

            this.showTabLevelError();
            this.hasError();
            if (this.isValidForm) {
                this.mdmValidation();
            }
        },

        /**
         * Scrolls the page to the first visible error.
         * And enable app if it's disabled.
         */
        hasError() {
            if ($('.error-border:visible').length === 0) {
                $('.showTabError:visible:first').click();
            }

            // Because this method can be called multiple times
            // (likely due to spaghetti coding), use isShowingError
            // to determine whether or not we're in the middle
            // of showing an error, and skip out if we are.
            if ($('.error-border:visible').length > 0 && !this.isShowingError) {
                this.isShowingError = true;
                $('html, body').animate({
                    scrollTop: $('.error-border:visible:first').offset().top - 200
                }, 700, 'swing', () => {
                    this.isShowingError = false;
                });
            }
        },

        onOnboardingSubmit: function() {
            if (this.isValidForm && this.isMDMValidForm) {
                globals.disableApp();
                $.ajax({
                    url: globals.path.api.westcon.submitOnboardForm + this.prospectId + '?' + CSRF,
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(this.currentModel)
                }).done((response) => {
                    globals.enableApp();
                    this.currentModel.clear();
                    this.serverErrors.html('');
                    if (response.submit === 'true') {
                        if (this.$('#internalUser').val() !== 'true') {
                            window.location.href = globals.path.api.westcon.prospectLogout + '?prospectsubmit=true';
                        } else {
                            this.eventAgg.trigger('customerOnboardingSubmitModal');
                        }
                    }
                }).fail((jqXHR, exception) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.serverErrors.html('Error :' + exception).removeClass('hidden');
                });
            }
        },

        zipCodeValidation: function(e, onload) {
            let getClass = onload ? onload : $(e.target).attr('class').split(' ')[0];
            let postCodeElement = this.$(`.${getClass}#postalcode`);
            let postCode = postCodeElement.val();
            let countryCode = this.$(`.${getClass}#country-${getClass}`).val();

            if (postCode) {
                globals.disableApp();
                this.zipCodeValidationApi.set({countryIsocode: countryCode, zipCode: postCode});
                this.zipCodeValidationApi.fetch().done((response) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    if (response) {
                        postCodeElement.removeClass('error-border').parent().find('.customError').html('').removeClass('show');
                    } else {
                        postCodeElement.addClass('error-border').parent().find('.customError').html('Please enter correct postal code').addClass('show');
                        this.isValidForm = false;
                    }
                }).fail((jqXHR, exception) => {
                    globals.enableApp();
                    this.serverErrors.html('');
                    this.serverErrors.html('Error :' + exception).removeClass('hidden');
                });
            } else {
                postCodeElement.removeClass('error-border').parent().find('.customError').html('').removeClass('show');
            }
        },

        checkIfSaved: function (e) {
            if (this.findTabNumber !== $(e.target).attr('tabnumber')) {
                if (Object.keys(this.currentModel.attributes).length > 0) {
                    this.eventAgg.trigger('saveRequestModal');
                }
            }
        },

        checkIfLoggedOut: function (e) {
            if (Object.keys(this.currentModel.attributes).length > 0) {
                this.eventAgg.trigger('loggedOutModalId');
            } else {
                window.location.href = globals.path.api.westcon.logout;
            }
        },

        searchSelectedLanguageChange: function(e, from) {
            if (Object.keys(this.currentModel.attributes).length > 0) {
                this.eventAgg.trigger('countryRequest', from, $(e.target).attr('class').split(' ')[0]);
            } else {
                this.eventAgg.trigger('searchSelectedLanguage', from, $(e.target).attr('class').split(' ')[0]);
            }
        }
    });
})(westcon);
